<template>
  <IQOS  :title="$t('integrations.order_title')">
    <div v-if="!request_sent">
      <p class="comment p-0">
        {{ $t("integrations.order_desc") }}
      </p>
      <BaseInput
        class="iqos-group-item"
        v-model="pos_name"
        :placeholder="$t('integrations.order_ph')"
        :readonly="false"
      />
      <DashboardButton
        class="iqos-button-right iqos-group-item"
        :disabled="!pos_name"
        @click="sendRequest"
      >
        {{ $t("integrations.order_button") }}
      </DashboardButton>
    </div>
    <div v-else>
      <p class="comment pt-0 c-green">
        {{ $t('integrations.order_sent') }}
      </p>
    </div>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";

import AnalyticsAPI from "@/api/analytics";

import BlackInput from "@/components/BlackInput.vue";
import DashboardButton from "@/components/DashboardButton.vue";

export default {
  data() {
    return {
      pos_name: null,

      request_sent: false,
    };
  },
  methods: {
    sendRequest() {
      AnalyticsAPI.sendOrderIntegration(
        this.$store.state.cafe._id,
        this.pos_name
      ).then(data => {
        this.request_sent = true;
      });
    },
  },
  components: {
    IQOS,
    DashboardButton,
    BlackInput,
  },
};
</script>

<style scoped>
input.pos-input {
  background: #ededed;
  width: 100%;
  border: none;
  text-align: center;
  padding: 0.5vh;
  border-radius: 0.5vh;
  margin-top: 2vh;
  outline: none;
}

button.order-btn {
  font-size: 1.7vh;
  display: block;
  margin-left: auto;
  border-radius: 0.8vh;
  border: none;
  outline: none;
  margin-top: 2vh;
  color: #ededed;
  padding: 0.6vh 1vh;
  background: #129b81;
}
</style>